import React from 'react'
import PageOverview from './Pages/Pageoverview'
import PageDetail from './Pages/PageDetail'
import PageNew from './Pages/new'
import CalenderDeleted from './Pages/deleted'

export const serviceauftragPagesConfig = (value: any) => {
    return [
        {
            path: '/serviceauftrag/overview/:page',
            roles: (process.env.REACT_APP_CALENDER_FORBIDDEN === 'true' ? ['Forbidden'] : ['superadmin', 'admin', 'consultant','engineer']),
            elements: <PageOverview value={value} />
        },
        {
            path: '/serviceauftrag/Detail/:id',
            roles: (process.env.REACT_APP_CALENDER_FORBIDDEN === 'true' ? ['Forbidden'] : ['superadmin', 'admin', 'consultant','engineer']),
            elements: <PageDetail value={value} />
        },
        {
            roles: (process.env.REACT_APP_CALENDER_FORBIDDEN === 'true' ? ['Forbidden'] : ['superadmin', 'admin', 'consultant','engineer']),
            path: '/serviceauftrag/Delete/:page/:deleteID',
            elements: <CalenderDeleted value={value} />
        },
        {
            path: '/serviceauftrag/new/:page',
            roles: (process.env.REACT_APP_CALENDER_FORBIDDEN === 'true' ? ['Forbidden'] : ['superadmin', 'admin', 'consultant','engineer']),
            elements: <PageNew value={value} />
        }
    ]
}
